import { Fragment, ReactElement, SyntheticEvent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../helpers/constans';
import {
  Box,
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Pagination,
} from '@mui/material';

import { styles } from './thing-table-qdos.styles';
import { thingQdosActions } from '../../redux/slices/thing-qdos';
import { EThingQdosStatusNum } from '../../types/@thingQdos';

const ThingTableQdos = (): ReactElement => {
  const { all: things, pages } = useSelector((state: RootState) => state.thingsQdos);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(thingQdosActions.getAllThings(1));
  }, [dispatch]);

  const handleClick = ({ currentTarget }: SyntheticEvent<HTMLTableRowElement>) => {
    navigate(`${ROUTES.thignsQdosMedia}/${currentTarget.dataset.id}`);
  };

  const handlePagination = (event: any, page: number) => {
    dispatch(thingQdosActions.getAllThings(page));
  };

  const formatStatus = (status: number): string => {
    switch (status) {
      case EThingQdosStatusNum.pending:
        return 'Pending';
      case EThingQdosStatusNum.saved:
        return 'Saved';
      case EThingQdosStatusNum.done:
        return 'Done';
      default:
        return 'Unknown';
    }
  };

  return (
    <Fragment>
      <TableContainer sx={styles.tableContainer}>
        <Table>
          <TableHead sx={styles.tableHead}>
            <TableRow>
              <TableCell>№</TableCell>
              <TableCell>Owner Name</TableCell>
              <TableCell>Recent Event Name</TableCell>
              <TableCell>QDOS Code</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={styles.tableBody}>
            {things.map((el, idx) => (
              <TableRow
                key={el._id}
                sx={styles.tableRow}
                data-id={el._id}
                hover={true}
                onClickCapture={handleClick}
              >
                <TableCell>{idx + 1}</TableCell>
                <TableCell>{el.owner?.name || 'Unnamed Owner'}</TableCell>
                <TableCell>{el.eventName || '—'}</TableCell>
                <TableCell>{el.alternativeId || '—'}</TableCell>
                <TableCell>{formatStatus(el.status)}</TableCell>
                <TableCell>{new Date(el.createdAt).toLocaleDateString()}</TableCell>
              </TableRow>
            ))}
            <TableRow></TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={styles.paginationBox}>
        <Pagination count={pages} onChange={handlePagination} />
      </Box>
    </Fragment>
  );
};

export default ThingTableQdos;
